var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _polygon, _path1, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaxScreenTemp01 = function SvgMaxScreenTemp01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 21.24,
    y1: 177.5,
    x2: 156.02,
    y2: -1.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.55,
    y1: 162.67,
    x2: 136.32,
    y2: -16.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -32.22,
    y1: 137.25,
    x2: 102.56,
    y2: -41.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -22.72,
    y1: 144.4,
    x2: 112.06,
    y2: -34.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 7.14,
    y1: 166.88,
    x2: 141.91,
    y2: -12.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 20.06,
    y1: 176.61,
    x2: 154.84,
    y2: -2.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -13.74,
    y1: 151.16,
    x2: 121.03,
    y2: -27.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 59.76,
    y1: 206.5,
    x2: 194.54,
    y2: 27.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 50.29,
    y1: 199.37,
    x2: 185.07,
    y2: 20.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 71.04,
    y1: 214.99,
    x2: 205.82,
    y2: 35.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 52.27,
    y1: 200.86,
    x2: 187.05,
    y2: 21.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 80.94,
    y1: 222.44,
    x2: 215.71,
    y2: 43.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 100.44,
    y1: 237.12,
    x2: 235.21,
    y2: 58.11,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M160.88,15.21c.87-.9.85-2.34-.05-3.22-.9-.87-2.35-.85-3.22.05l-118.36,118.36c-.43.43-.67,1-.67,1.61,0,1.26,1.02,2.28,2.28,2.28.6,0,1.18-.24,1.61-.67L160.83,15.27s.04-.04.05-.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.55,95.7c.42.43,1.01.68,1.61.68h0c.59-.01,1.16-.25,1.58-.66.9-.88.91-2.32.03-3.22-6.95-7.06-10.81-16.59-10.72-26.49,0-20.08,15.32-36.42,34.14-36.42,10.16.07,19.74,4.79,25.99,12.8.78.93,2.15,1.08,3.12.35,1-.76,1.2-2.19.44-3.19-7.11-9.1-18-14.44-29.55-14.51-21.34,0-38.69,18.38-38.69,40.97-.09,11.1,4.24,21.79,12.04,29.69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.18,31.2c.43.43,1.01.67,1.61.67s1.18-.24,1.61-.67c.89-.89.89-2.33,0-3.22l-9.1-9.1c-.88-.85-2.28-.85-3.16,0-.9.87-.93,2.31-.05,3.22l9.1,9.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.41,66.01c0-1.26-1.02-2.28-2.28-2.28h-13.66c-1.26,0-2.28,1.02-2.28,2.28s1.02,2.28,2.28,2.28h13.66c1.26,0,2.28-1.02,2.28-2.28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47.68,113.81c.6,0,1.18-.24,1.61-.67l9.1-9.11c.85-.88.85-2.28,0-3.16-.87-.9-2.31-.93-3.22-.06l-9.1,9.1c-.43.43-.67,1.01-.67,1.61,0,1.26,1.02,2.28,2.28,2.28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M129.62,31.87c.6,0,1.18-.24,1.61-.67l9.1-9.11c.85-.88.85-2.28,0-3.16-.87-.9-2.31-.93-3.22-.06l-9.1,9.1c-.43.43-.67,1.01-.67,1.61,0,1.26,1.02,2.28,2.28,2.28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M93.21,18.21c1.26,0,2.28-1.02,2.28-2.28V2.28C95.48,1.02,94.46,0,93.21,0s-2.28,1.02-2.28,2.28v13.66c0,1.26,1.02,2.28,2.28,2.28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.39,112.81c-.72-1.03-2.14-1.28-3.17-.56-5.11,3.59-11.21,5.51-17.46,5.49-16.47.11-29.93-13.12-30.08-29.59,0-4.98,1.27-9.87,3.68-14.21.3-.55.37-1.19.18-1.78-.38-1.2-1.65-1.87-2.85-1.49-16.34,4.99-27.4,20.19-27.13,37.27.34,21.18,17.77,38.07,38.95,37.73,18.55.08,34.57-12.95,38.26-31.13.12-.61-.01-1.23-.37-1.74M135.24,141.12c-19.05.36-34.78-14.79-35.14-33.84.01-12.87,7.35-24.6,18.91-30.25-1.25,3.58-1.88,7.34-1.88,11.13.16,18.98,15.65,34.26,34.64,34.14,5.21.01,10.36-1.14,15.06-3.39-5.01,13.15-17.51,21.93-31.58,22.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M145.56,79.67c1.26,0,2.28-1.02,2.28-2.28v-2.28h2.28c1.26,0,2.28-1.02,2.28-2.28s-1.02-2.28-2.28-2.28h-2.28v-2.28c0-1.26-1.02-2.28-2.28-2.28s-2.28,1.02-2.28,2.28v2.28h-2.28c-1.26,0-2.28,1.02-2.28,2.28s1.02,2.28,2.28,2.28h2.28v2.28c0,1.26,1.02,2.28,2.28,2.28"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.49,91.05c0-1.26-1.02-2.28-2.28-2.28s-2.28,1.02-2.28,2.28v4.55h-4.55c-1.26,0-2.28,1.02-2.28,2.28s1.02,2.28,2.28,2.28h4.55v4.55c0,1.26,1.02,2.28,2.28,2.28s2.28-1.02,2.28-2.28v-4.55h4.55c1.26,0,2.28-1.02,2.28-2.28s-1.02-2.28-2.28-2.28h-4.55v-4.55Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "41.3 200 48.49 163 54.65 163 63.24 185.65 71.85 163 78.01 163 85.2 200 77.75 200 73.65 178.78 65.75 199.63 60.73 199.63 52.85 178.78 48.73 200 41.3 200"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.9,163h8.3l13.42,37h-7.74l-2.22-6.13h-15.22l-2.22,6.13h-7.74l13.43-37ZM100.11,186.57h9.89l-4.97-13.56-4.92,13.56Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "124.18 200 137.72 181.39 124.34 163 133.33 163 142.23 175.21 151.14 163 160.13 163 146.75 181.39 160.29 200 151.25 200 142.23 187.63 133.22 200 124.18 200"
  })));
};
export default SvgMaxScreenTemp01;